var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');
var Utils = require('front/utils/Utils');

var template = require('./PaintingsContentUser.jinja');
require('./PaintingsContentUser.less');

module.exports = Backbone.View.extend({

    initialize: function (options) {
        _.extend(this, options);

        _.bindAll(this, 'onResize');
    },


    activate: function (params) {
        console.log('activate PaintingsContentUser');

        this.parent = params.parent;

        if (!this.$dom) {
            this.$dom = $(template.render({data: {}}));

            this.$dom.appendTo(params.$parent);

            this.$dom.find('.PaintingsContentUser-shareFB').on('click', this.onShareFBClick);
            this.$dom.find('.PaintingsContentUser-shareVK').on('click', this.onShareVKClick);
            this.$dom.find('.PaintingsContentUser-shareOK').on('click', this.onShareOKClick);

            $.ajax({
                'url': app.settings.api_url + this.paintingId + '/' + this.userKey + '.json',
                'method': 'GET',
                'success': this.onApiSuccess,
                'error': this.onApiError,
                'context': this
            });
        } else {
            //просто вставляем дум обратно в контейнер
            this.$dom.appendTo(params.$parent);
            this.onResize();
        }

        $(window).on('resize', this.onResize);
    },


    onShareFBClick: function () {
        window.open(
            'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location),
            'facebooksharedialog',
            'width=626,height=436');
    },


    onShareVKClick: function () {
        window.open(
            'http://vk.com/share.php?url=' + encodeURIComponent(window.location),
            'vksharedialog',
            'width=626,height=436');
    },


    onShareOKClick: function () {
        window.open(
            'https://connect.ok.ru/offer?url=' + encodeURIComponent(window.location),
            'oksharedialog',
            'width=626,height=436');
    },


    onApiSuccess: function (data) {

        if (data.error) {
            delete this.$dom;
            Backbone.history.navigate('/', {trigger: 'true'});

            return;
        }

        this.data = data;

        this.$dom
            .find('.PaintingsContentUser-paintingImage')
            .css('background-image', 'url(' + window.app.settings.image_folder + data.i + ')');

        this.$dom
            .find('.PaintingsContentUser-userImage')
            .css('background-image', 'url(' + window.app.settings.people_image_url.replace('##', data.s[0].p).replace('#', this.paintingId) + ')');

        this.minX = 99999;
        this.minY = 99999;
        this.maxX = 0;
        this.maxY = 0;

        for (var i = 0; i < data.s[0].c.length; i++) {
            var strokeCoord = data.s[0].c[i];
            var mx = ((strokeCoord[0] + strokeCoord[2]) / 2) / 100; //получаем середину строка и переводим в проценты (/100) у на вместо относительных координат 0..1 относительные умноженные на 10000, для того чтобы не работать с флоатами при пересылке, 0. дорого весят
            var my = ((strokeCoord[1] + strokeCoord[3]) / 2) / 100;
            $('<div>')
                .addClass('PaintingsContentUser-dot')
                .css({
                    left: mx + '%',
                    top: my + '%'
                })
                .appendTo(this.$dom.find('.PaintingsContentUser-linesWrapper'));

            //это чтобы найти геометрический центр всех строуков
            this.minX = Math.min(this.minX, mx);
            this.minY = Math.min(this.minY, my);
            this.maxX = Math.max(this.maxX, mx);
            this.maxY = Math.max(this.maxY, my);
        }

        this.$dom.find('.PaintingsContentUser-user')
            .removeClass('PaintingsContentUser-user--hidden');

        this.onResize();
    },


    positionUserAndLines: function () {
        var cx = (this.minX + this.maxX) / 2 / 100; //проценты переводим в 0..1
        var cy = (this.minY + this.maxY) / 2 / 100;

        var w = this.$dom.width();
        var h = this.$dom.height();

        var data = this.data;

        var minPaddings = {
            l: 0,
            t: 0,
            r: 0,
            b: 0
        };

        //ставим минимальные границы для cx cy, чтобы фотка не оказалась совсем на границах
        //для < 1024 Другая верстка и другие паддинги минимальные
        if (window.innerWidth < 1024) {
            minPaddings = {
                l: 90,
                t: 90,
                r: 90,
                b: 110
            };
        } else {
            minPaddings = {
                l: 130,
                t: 130,
                r: 90,
                b: 90
            };
        }


        if (cx * w < minPaddings.l) {
            cx = minPaddings.l / w;
        }

        if (cy * h < minPaddings.t) {
            cy = minPaddings.t / h;
        }

        if (w - cx * w < minPaddings.r) {
            cx = 1 - minPaddings.r / w;
        }

        if (h - cy * h < minPaddings.b) {
            cy = 1 - minPaddings.b / h;
        }


        var lines = [];

        //рисуем точечные свг линии
        for (var i = 0; i < data.s[0].c.length; i++) {
            var strokeCoord = data.s[0].c[i];
            var mx = ((strokeCoord[0] + strokeCoord[2]) / 2) / 10000;
            var my = ((strokeCoord[1] + strokeCoord[3]) / 2) / 10000;
            var x1 = w * mx;
            var y1 = h * my;
            var x2 = w * cx;
            var y2 = h * cy;

            var dx = x2 - x1;
            var dy = y2 - y1;
            var len = Math.pow(dx * dx + dy * dy, 0.5);

            x1 += dx / len * 4;
            y1 += dy / len * 4;

            lines.push('<line vector-effect="non-scaling-stroke" x1="' + x1 + '" x2="' + x2 + '" y1="' + y1 + '" y2="' + y2 + '"></line>');
        }

        this.$dom.find('.PaintingsContentUser-linesWrapper svg').remove();

        $('<svg class="PaintingsContentUser-lines" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + w + ' ' + h + '">' + lines.join('') + '</svg>')
            .appendTo(this.$dom.find('.PaintingsContentUser-linesWrapper'));


        this.$dom.find('.PaintingsContentUser-user')
            .css({
                left: cx * 100 + '%',
                top: cy * 100 + '%'
            });
    },


    onResize: function () {
        this.positionUserAndLines();

        //на телефоне  надо проскролить так чтобы юзер был по центру
        if (app.settings.isPhone)  {

            var $user = this.$dom.find('.PaintingsContentUser-user');

            if (window.innerWidth < window.innerHeight) {
                var pos = $user.position().left;
                var ww = window.innerWidth;
                var scrollOffset = pos - ww / 2;
                console.log(pos, ww, scrollOffset);
                this.parent.scrollLeft(scrollOffset);
            } else {
                var pos = $user.position().top;
                var wh = window.innerHeight - 100;
                var scrollOffset = pos - wh / 2;
                this.parent.scrollTop(scrollOffset);
            }
        }
    },


    onApiError: function () {
        console.log(arguments);
    },


    deactivate: function (params) {
        console.log('deactivate PaintingsContentUser');
        this.$dom.detach();

        $(window).off('resize', this.onResize);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Index/PaintingsContentUser.js
// module id = 31
// module chunks = 0